<template>
    <v-container fluid>
        <!--    Diálogo Persistente para mostrar Correccion de Datos    -->
        <v-dialog v-model="dialog_correction_request" persistent width="500">
            <v-card class="justify-center">
                <v-card-title class="primary display-1 text--primary justify-center">
                    {{$t('data_correction')}}
                </v-card-title>
                <v-card-text align="center">
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="first_name_correction"
                          prepend-icon="mdi-account"
                          name="first_name"
                          :label="$t('Nombre')"
                          :error-messages="errores.first_name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="last_name_correction"
                          prepend-icon="mdi-account-outline"
                          name="last_name"
                          :label="$t('Apellido')"
                          :error-messages="errores.last_name"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                          v-model="msg_photograph_blurred"
                          :label="$t('msg_photograph_blurred')">
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_correction_request = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                            color="primary"
                            :loading="loading_correction_request"
                            @click="send_correction_request()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores en Accesos    -->
        <v-dialog v-model="dialog_errores" persistent width="500">
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text align="center">
                    <h3 class="text-xs-center">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = ''"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entradaResidente" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_residente')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.resident).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.resident.idUser.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('residente')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.idUser.first_name}}
                                                        {{ info_invitation.resident.idUser.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.street}} {{info_invitation.resident.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{  info_invitation.resident.idUser.cellNumber}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="success"
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true, deleteRecord()"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="error"
                            @click="dialog = false, activar_camara = true"
                    >{{this.$t('cerrar')}}
                    </v-btn>
                    <v-btn
                            large
                            color="success"
                            @click="create_acceso(), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                                <br>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('celular')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('numero_casa')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('Información de Acceso')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de acceso')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_EntranceAccess}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de salida')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_ExitAccess ? data_access[0].dateTime_ExitAccess : "Pendiente" }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Estado')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{data_access[0].status == '1' ? "Adentro" : "Afuera"}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialog = false, activar_camara = true"
                        >{{ $t('cerrar')}}
                        </v-btn>
                        <v-btn
                                large
                                color="success"
                                @click="update_acceso(data_access[0].id), activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogData" persistent
                scrollable
                width="700">
            <v-card class="mx-auto elevation-7">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_without_code')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="clear(), dialogData = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text align="center">
                    <v-row>
                        <v-col>
                            <img  width="400" height="250" :src="imageCaptured">
                            <v-autocomplete
                                    autofocus
                                    v-model="idHouse"
                                    prepend-icon="mdi-home-city"
                                    name="idHouse"
                                    :item-text="example"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errors.house"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    outlined
                                    autocomplete="off"
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    outlined
                                    :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    outlined
                                    :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-textarea
                                    v-model="notes"
                                    autocomplete="on"
                                    prepend-icon="mdi-text"
                                    name="notes"
                                    :placeholder="$t('placeholder_notas')"
                                    :label="$t('Notas')"
                                    outlined
                                    :error-messages="errors.comments"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="primary"
                            :loading="loading"
                            @click="createAccessWithoutCode()"
                    >{{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row align="center" justify="center">
          <v-col
              class="text-sm-center"
              cols="10"
          >
            <v-tabs v-model="tabActivo" fixed-tabs background-color="primary">
              <v-tab>
                <div v-show="photosCamera.length > 0">
                  <v-badge color="black">
                    <template v-slot:badge>
                      <span>{{photosCamera.length}}</span>
                    </template>
                    <span>{{$t('acceso_sin_codigo')}}</span>
                  </v-badge>
                </div>
                <div v-show="photosCamera.length === 0">
                  {{$t('acceso_sin_codigo')}}
                </div>
              </v-tab>
              <v-tab>
                <div v-show="qrCodes.length > 0">
                  <v-badge color="black">
                    <template v-slot:badge>
                      <span>{{qrCodes.length}}</span>
                    </template>
                    <span>{{$t('entradas_salidas')}}</span>
                  </v-badge>
                </div>
                <div v-show="qrCodes.length === 0">
                  {{$t('entradas_salidas')}}
                </div>
              </v-tab>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text class="py-4 font-weight-bold">
                    <v-card>
                      <v-toolbar dark color="primary">
                        <v-icon v-if="getProfile.enable_parcel === false">mdi-truck</v-icon>
                        <v-checkbox hide-details class="shrink mr-2" v-if="getProfile.enable_parcel === false" v-model="bandParcel" color="black"></v-checkbox>
                        {{getProfile.enable_parcel === false ? $t('parcel_capital_letters') : ''}}
                        <v-btn text router to="/events"><v-icon >mdi-calendar-star</v-icon>{{$t('events')}}</v-btn>
                        <v-btn text router to="/delivery"><v-icon>mdi-moped</v-icon>Delivery</v-btn>
                        <v-spacer/>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                dark
                                fab
                                icon
                                x-large
                                class="mr-2"
                                :loading="loadingTakePicture"
                                @click="takePicture1"
                            >
                              <v-icon>
                                mdi-camera
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('capture_photo')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="red"
                                dark
                                class="mr-2"
                                @click="deleteItemPhoto(0)"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                          <span>{{$t('delete')}}</span>
                        </v-tooltip>
                      </v-toolbar>
                      <v-card-text>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="11"
                          >
                            <v-alert
                                v-show="bandMsgVacationMode"
                                type="error"
                                outlined
                            >
                              <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                            </v-alert>
                            <v-alert
                                v-show="bandInstructions"
                                type="info"
                                outlined
                            >
                              <strong>{{ msgInstructions }}</strong>
                            </v-alert>
                            <br>
                            <v-autocomplete
                                v-show="bandParcel"
                                v-model="idHouse2"
                                :search-input.sync="searchInput"
                                @change="searchInput=''"
                                prepend-icon="mdi-home-city"
                                name="idHouse2"
                                :item-text="example"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number')"
                                :filter="customFilterNumber"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                outlined
                                multiple
                                chips
                                clearable
                                autocomplete="off"
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    large
                                    v-if="getProfile.show_house_phones === false"
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove(data.item)"
                                >
                                  <strong>{{ data.item.street }} {{data.item.number}}</strong>
                                </v-chip>
                                <v-chip
                                    v-else
                                    large
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove(data.item)"
                                >
                                  <strong>{{ data.item.street }} {{data.item.number}} ({{data.item.phone === null ? 'n/a' : data.item.phone}}) ({{data.item.phone2 === null ? 'n/a' : data.item.phone2}}) ({{data.item.phone3 === null ? 'n/a' : data.item.phone3}})</strong>
                                </v-chip>
                              </template>
                              <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                <v-spacer/>
                                <v-btn-toggle>
                                  <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                              <template v-slot:item="data" v-else>
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                                v-show="!bandParcel"
                                v-model="idHouse"
                                prepend-icon="mdi-home-city"
                                name="idHouse"
                                :item-text="getProfile.show_house_phones === false ? example : example2"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number')"
                                :filter="customFilterNumber"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                return-object
                                autocomplete="off"
                                @change="showMessageVacationMode"
                            >
                              <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                <v-spacer/>
                                <v-btn-toggle>
                                  <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                              <template v-slot:item="data" v-else>
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="1"
                              class="text-right"
                          >
                            <v-btn
                                v-show="photosCamera.length !== 0"
                                icon
                                large
                                color="primary"
                                :loading="loading"
                                @click="indexTag = 0, imageCaptured = 'data:image/jpeg;base64,' + photosCamera[0].data, rotateBase64Image180deg(imageCaptured, true, 0)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>180°</span>
                                </v-tooltip>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="5"
                          >
                            <div class="text--accent-1" v-show="getProfile.show_directory_guards === true && !bandParcel">
                              <div class="ml-6" v-show="idHouse.phone !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name1 === null) || (idHouse.name1 === '')) ? 'n/a' : idHouse.name1}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone2 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name2 === null) || (idHouse.name2 === '')) ? 'n/a' : idHouse.name2}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone2}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone3 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name3 === null) || (idHouse.name3 === '')) ? 'n/a' : idHouse.name3}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone3}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone4 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name4 === null) || (idHouse.name4 === '')) ? 'n/a' : idHouse.name4}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone4}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone5 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name5 === null) || (idHouse.name5 === '')) ? 'n/a' : idHouse.name5}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone5}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone6 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name6 === null) || (idHouse.name6 === '')) ? 'n/a' : idHouse.name6}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone6}}</strong></h2><br></div><br>
                            </div>
                            <v-autocomplete
                                v-show="!bandParcel"
                                v-model="idService"
                                prepend-icon="mdi-tag-multiple"
                                name="idService"
                                :item-text="textServices"
                                item-value="name"
                                :label="$t('service_catalog')"
                                :placeholder="$t('search_by_name')"
                                :filter="customFilterService"
                                :items="services"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                autocomplete="off"
                            >
                              <template v-slot:item="data">
                                <strong>{{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                              </template>
                            </v-autocomplete>
                            <v-text-field
                                v-model="first_name"
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('Nombre')"
                                outlined
                                :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="last_name"
                                prepend-icon="mdi-account-outline"
                                name="last_name"
                                :label="$t('Apellido')"
                                outlined
                                :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-textarea
                                v-model="notes"
                                autocomplete="on"
                                prepend-icon="mdi-text"
                                name="notes"
                                :placeholder="$t('placeholder_notas')"
                                :label="$t('Notas')"
                                outlined
                                :error-messages="errors.comments"
                            ></v-textarea>
                            <div align="center">
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  :loading="loading"
                                  @click="indexTag = 0, imageCaptured = 'data:image/jpeg;base64,' + photosCamera[0].data, createAccessNoCode()">
                                {{$t('acceso')}}
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="7"
                          >
                            <v-row>
                              <v-img
                                  v-if="photosCamera.length !== 0"
                                  :src="'data:image/jpeg;base64,' + photosCamera[0].data"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                              <v-img
                                  v-else
                                  :src="require('../../assets/noimage.png')"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
<!--                    <v-card v-show="photosCamera.length === 0">-->
<!--                      <v-card-text class="text-center">-->
<!--                        <v-spacer/>-->
<!--                        <h2>{{$t('no_registros
      bandParcel: false,_pase_salida')}}</h2>-->
<!--                      </v-card-text>-->
<!--                    </v-card>-->
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text class="py-0">
                    <v-timeline dense v-if="qrCodes.length !== 0">
                      <v-slide-x-transition
                          group
                          hide-on-leave
                      >
                        <v-timeline-item
                            v-for="(item, index) in qrCodes"
                            :key="item.data"
                            small
                            fill-dot
                        >
                          <v-card v-if="item.status === -5">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_vacation_mode_activate')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-if="item.status === -3">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_canceled_invitation')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === -1">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_residente')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-alert
                                      v-show="item.info.resident.vacation_mode && !item.info.resident.allow_access_residents"
                                      type="error"
                                  >
                                    <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                  </v-alert>
                                  <v-alert
                                      v-show="item.info.resident.instructions !== '' && item.info.resident.instructions !== null"
                                      type="info"
                                  >
                                    <strong>{{ item.info.resident.instructions }}</strong>
                                  </v-alert>
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.resident.idUser.idFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.resident.idUser.first_name}}
                                            {{ item.info.resident.idUser.last_name}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.resident.street}} {{item.info.resident.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{  item.info.resident.idUser.cellNumber}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer/>
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="deleteItem(index)">
                                {{$t('acceso')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else-if="item.status === 0">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('mensaje_qr_no_valido')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 1">
                            <v-toolbar dark color="orange">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="orange"
                                  border="left"
                                  type="warning"
                                  outlined
                              >
                                {{$t('mensaje_acceso_completo')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 2">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <br>
                              <v-alert
                                  v-show="item.info.invitation.supplier"
                                  type="info"
                                  outlined
                              >
                                <strong>{{$t('supplier_mode')}}</strong>{{$t('msg_supplier')}}
                              </v-alert>
                              <v-alert
                                  v-show="item.info.invitation.vacation_mode && !item.info.invitation.allow_access_visitors"
                                  type="error"
                              >
                                <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                              </v-alert>
                              <v-alert
                                  v-show="item.info.invitation.instructions !== '' && item.info.invitation.instructions !== null"
                                  type="info"
                              >
                                <strong>{{ item.info.invitation.instructions }}</strong>
                              </v-alert>
                              <br>
                              <v-layout row wrap>
                                <h4>{{$t('info_invitado')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.invitation.guestIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('Visitante')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestFName}}
                                            {{ item.info.invitation.guestLName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('Asunto')}}
                                          </th>
                                          <td>
                                            {{ item.info.invitation.subject}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('dias_validos')}}:
                                          </th>
                                          <td>
                                            {{item.info.invitation.diary.includes('0') === true ? $t('Lunes') : ''}}
                                            {{item.info.invitation.diary.includes('1') === true ? $t('Martes') : ''}}
                                            {{item.info.invitation.diary.includes('2') === true ? $t('Miercoles') : ''}}
                                            {{item.info.invitation.diary.includes('3') === true ? $t('Jueves') : ''}}
                                            {{item.info.invitation.diary.includes('4') === true ? $t('Viernes') : ''}}
                                            {{item.info.invitation.diary.includes('5') === true ? $t('Sabado') : ''}}
                                            {{item.info.invitation.diary.includes('6') === true ? $t('Domingo') : ''}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('fecha_expiracion')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.expiration }}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout v-show="item.info.invitation.correction_request === false" align-center justify-center row wrap>
                                  <v-btn
                                      large
                                      color="error"
                                      @click="index_correction_request = index, id_user_settings = item.info.invitation.id_user_settings, errores = [], first_name_correction = item.info.invitation.guestFName, last_name_correction = item.info.invitation.guestLName, msg_photograph_blurred = true, dialog_correction_request = true"
                                  >{{$t('send_correction_request')}}
                                  </v-btn>
                              </v-layout>
                              <v-layout v-show="item.info.invitation.correction_request === true" align-center justify-center row wrap>
                                  <v-btn
                                      disabled
                                      large
                                      color="error"
                                  >{{$t('data_correction_sent')}}
                                  </v-btn>
                              </v-layout>
                              <v-layout v-show="getProfile.enable_host_info" row wrap>
                                <h4>{{$t('info_anfitrion')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          v-if="getProfile.enable_ine_photo"
                                          :src="item.info.invitation.hostIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                      <v-img
                                          v-else
                                          :src="item.info.invitation.avatarHost"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostFirstName}}
                                            {{ item.info.invitation.hostLastName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-center">
                                <v-text-field
                                    class="mt-8"
                                    v-model="comments"
                                    name="comments"
                                    outlined
                                    autocomplete="off"
                                    maxlength="300"
                                    prepend-icon="mdi-text"
                                    :label="$t('Notas')"
                                ></v-text-field>
                                ---
                                <v-btn
                                    x-large
                                    color="primary"
                                    @click="create_acceso(index, item.data)">
                                  {{$t('acceso')}}
                                </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else-if="item.status === 3">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_invitado')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.invitation.guestIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('Visitante')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestFName}}
                                            {{ item.info.invitation.guestLName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('Asunto')}}
                                          </th>
                                          <td>
                                            {{ item.info.invitation.subject}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('dias_validos')}}:
                                          </th>
                                          <td>
                                            {{item.info.invitation.diary.includes('0') === true ? $t('Lunes') : ''}}
                                            {{item.info.invitation.diary.includes('1') === true ? $t('Martes') : ''}}
                                            {{item.info.invitation.diary.includes('2') === true ? $t('Miercoles') : ''}}
                                            {{item.info.invitation.diary.includes('3') === true ? $t('Jueves') : ''}}
                                            {{item.info.invitation.diary.includes('4') === true ? $t('Viernes') : ''}}
                                            {{item.info.invitation.diary.includes('5') === true ? $t('Sabado') : ''}}
                                            {{item.info.invitation.diary.includes('6') === true ? $t('Domingo') : ''}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('fecha_expiracion')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.expiration }}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout v-show="getProfile.enable_host_info" row wrap>
                                <h4>{{$t('info_anfitrion')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          v-if="getProfile.enable_ine_photo"
                                          :src="item.info.invitation.hostIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                      <v-img
                                          v-else
                                          :src="item.info.invitation.avatarHost"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostFirstName}}
                                            {{ item.info.invitation.hostLastName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-xs-center">
                              <v-spacer/>
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="update_acceso(index, item.access)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else-if="item.status === 4">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 5">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date2')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 6">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date3')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 10 || item.status === 11">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_worker')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-alert
                                      v-show="item.info.worker.vacation_mode && !item.info.worker.allow_access_workers"
                                      type="error"
                                  >
                                    <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                  </v-alert>
                                  <v-alert
                                      v-show="item.info.worker.instructions !== '' && item.info.worker.instructions !== null"
                                      type="info"
                                  >
                                    <strong>{{ item.info.worker.instructions }}</strong>
                                  </v-alert>
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.worker.avatar"
                                          position="center center"
                                          class="grey lighten-2"
                                          width="300px"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('worker')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.first_name}}
                                              {{ item.info.worker.last_name}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('numero_casa')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.street}} {{item.info.worker.numberHouse}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('check_in_time')}}
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.check_in_time}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('check_out_time')}}
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.check_out_time}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('fecha_inicial')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.initial_date }}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('fecha_expiracion')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.final_date }}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('dias_validos')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3 v-if="item.info.worker.diary.includes('0') === true">
                                              {{ $t('Lunes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('1') === true">
                                              {{ $t('Martes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('2') === true">
                                              {{ $t('Miercoles') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('3') === true">
                                              {{ $t('Jueves') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('4') === true">
                                              {{ $t('Viernes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('5') === true">
                                              {{ $t('Sabado') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('6') === true">
                                              {{ $t('Domingo') }}
                                            </h3>
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-xs-center">
                              <v-spacer/>
                              <v-btn
                                  v-if="item.status === 10"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="item.status === 11"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else-if="item.status === 12">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date_worker0')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 13">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date_worker1')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- LISTA DE INVITADOS A EVENTO-->
                          <v-card v-else-if="item.status === 20">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{$t('event_data')}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="heading text-justify black--text">
                                    <p>
                                      <br><strong>{{$t('event_name')}}: <BIG><U>{{item.info.event.name}}</U></BIG></strong><br>
                                      <strong>{{$t('direccion')}}: <BIG>{{item.info.event.address}}</BIG></strong><br>
                                      <strong>{{$t('Fecha')}}: <BIG>{{item.info.event.date}}</BIG></strong>&nbsp;&nbsp;&nbsp;
                                      <strong>{{$t('event_time')}}: <BIG>{{item.info.event.time}}</BIG></strong><br>
                                    </p>
                                  </div>
                                </v-flex>
                                <v-flex xs12>
                                  <table style="width:100%">
                                  <tr>
                                    <th>{{ $t('invitados') }}</th>
                                    <th>{{ $t('estado') }}</th>
                                  </tr>
                                  <tr v-for="item3 in item.info.guests" :key="item3.id">
                                    <td><strong><BIG>{{ item3.fullName }}</BIG></strong></td>
                                    <td v-if="item3.status === 0">
                                      <v-btn
                                          @click="checkInGuestByEvent(item.info.event, item3), deleteItem(index)"
                                          color="primary">
                                          {{$t('complete_register')}}
                                      </v-btn>
                                    </td>
                                    <td v-else>
                                      <v-icon color="primary">mdi-check</v-icon>{{$t('adentro')}}
                                    </td>
                                  </tr>
                                </table>
                                  <!-- <v-data-table
                                      :headers="headersEvent"
                                      :hide-default-footer="true"
                                      :items="item.info.guests"
                                      :footer-props="{
                                                        itemsPerPageOptions: [
                                                            {text: '5', value: 5},
                                                            {text: '10', value: 10},
                                                            {text: '25', value: 25},
                                                            {text: this.$t('todos'), value: -1}
                                                        ],
                                                        itemsPerPageText: $t('filas_por_pagina')
                                                    }"
                                      :no-data-text="$t('no_records_yet')"
                                      class="elevation-1"
                                  >
                                  </v-data-table> -->
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE EVENTO CANCELADO -->
                          <v-card v-else-if="item.status === 21">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_event_canceled')}}</v-alert>
                            </v-card-text>
                          </v-card>
                        </v-timeline-item>
                      </v-slide-x-transition>
                    </v-timeline>
                    <v-timeline v-else>
                      <v-timeline-item >
                        {{$t('no_registros_pase_salida')}}
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
    </v-container>
</template>s

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import axios from 'axios'

const COLORS = [
  'info',
  'warning',
  'error',
  'success'
]
const ICONS = {
  info: 'mdi-qrcode',
  warning: 'mdi-camera',
  error: 'mdi-alert-circle',
  success: 'mdi-check-circle'
}

export default {
  name: 'checkin_checkout_qr',
  data () {
    return {
      // access no code
      dialogData: false,
      houses: [],
      errors: [],
      first_name: '',
      last_name: '',
      celular: '',
      notes: '',
      idHouse: {
        id: ''
      },
      imageCaptured: '',
      indexTag: -1,
      // access no code
      tab: null,
      activar_camara: true,
      qr_code: '',
      error: '',
      valido: false,
      a_qr_code: '',
      salida: false,
      entrada: false,
      entradaResidente: false,
      data_access: [],
      errores_guard: '',
      head_color: '',
      info_invitation: [],
      bandMsgVacationMode: false,
      bandInstructions: false,
      msgInstructions: '',
      dialog: false,
      comments: '',
      dialog_errores: false,
      dialogInitial: false,
      loading: false,
      loadingTakePicture: false,
      guardHouse: null,
      guardHouses: [],
      labelDevice: '',
      // Example
      interval: null,
      items: [
        {
          id: 1,
          color: 'info',
          icon: ICONS.info
        }
      ],
      nonce: 2,
      rotateimage: '',
      idService: '',
      tabActivo: 0,
      services: [],
      bandParcel: false,
      idHouse2: [],
      // VARIABLES CORRECCION DE DATOS
      dialog_correction_request: false,
      first_name_correction: '',
      last_name_correction: '',
      id_user_settings: 0,
      errores: [],
      searchInput: '',
      loading_correction_request: false,
      msg_photograph_blurred: true,
      index_correction_request: -1,
      // VARIABLES CORRECCION DE DATOS,
      idGuestByEvent: null,
      idGuestByDelivery: null
    }
  },
  created () {
    this.tabActivo = parseInt(this.$route.params.tab)
    this.getHouses()
    this.getServices()
    console.log(this.$route.params)
    console.log('Tamaño =', Object.keys(this.$route.params).length)
    if (Object.keys(this.$route.params).length > 2) {
      this.tabActivo = 0
      if (this.$route.params.type === 0) { // EVENTO
        this.first_name = this.$route.params.fullNameGuest + ' (EVENTO)'
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByEvent = this.$route.params.idGuestByEvent
        this.notes = this.$route.params.eventName
      } else { // DELIVERY
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByDelivery = this.$route.params.idGuestByDelivery
        this.notes = this.$route.params.notes
        this.first_name = this.$route.params.personName
      }
    }
  },
  computed: {
    ...mapState(['qrDevices', 'qrCodes', 'photosCamera']),
    ...mapGetters(['getProfile'])
  },
  // watch: {
  //   photosCamera () {
  //     if (this.photosCamera.length !== 0) {
  //       this.first_name = this.photosCamera[0].fullTextAnnotation
  //     }
  //   }
  // },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    checkInGuestByEvent (dataEvent, item) {
      this.tabActivo = 0
      this.first_name = item.fullName + ' (EVENTO)'
      this.idHouse = {
        id: dataEvent.idHouse
      }
      this.idGuestByEvent = item.id
      this.notes = dataEvent.name
    },
    remove: function (item) {
      console.log(this.idHouse2)
      console.log(this.idHouse2[0])
      const index = this.idHouse2.indexOf(item.id)
      console.log(index)
      if (index >= 0) this.idHouse2.splice(index, 1)
    },
    createAccessNoCode () {
      console.log('idHouse = ', this.idHouse)
      console.log('idHouse2 = ', this.idHouse2)
      if (this.bandParcel === true) {
        this.createManyAccessNoCode()
      } else {
        this.createAccessWithoutCode()
      }
    },
    createManyAccessNoCode () {
      this.loading = true
      this.errors = []
      console.log('TAM ====> ', this.idHouse2.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      for (let i = 0; i < this.idHouse2.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('housing_unit', this.getProfile.idHousingUnit)
        bodyFormData.append('house', this.idHouse2[i])
        bodyFormData.append('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))
        bodyFormData.append('name_guest', this.first_name + ' ' + this.last_name)
        bodyFormData.append('comments', this.notes)
        if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
          fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
        }
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_many_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          this.deleteItemPhoto(this.indexTag)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    send_correction_request () {
      this.errores = []
      this.loading_correction_request = true
      console.log(this.qr_code)
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/user/update/correction_request/' + this.id_user_settings,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          first_name: this.first_name_correction,
          last_name: this.last_name_correction
        }
      }
      axios(config)
        .then(response => {
          this.loading_correction_request = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('registro_exito'))
          this.dialog_correction_request = false
          this.updateItemCorrectionRequest(this.index_correction_request)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading_correction_request = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    showMessageVacationMode () {
      console.log('Fill Houses')
      console.log(this.idHouse)
      if (this.idHouse === undefined) {
        this.idHouse = {
          id: ''
        }
        this.bandMsgVacationMode = false
        this.bandInstructions = false
        this.msgInstructions = ''
      } else {
        if (this.idHouse.vacation_mode && !this.idHouse.allow_access_visitors) {
          this.bandMsgVacationMode = true
        } else {
          this.bandMsgVacationMode = false
        }
        if (this.idHouse.instructions !== '' && this.idHouse.instructions !== null) {
          this.bandInstructions = true
          this.msgInstructions = this.idHouse.instructions
        } else {
          this.bandInstructions = false
          this.msgInstructions = ''
        }
      }
    },
    getHouses () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/resident_house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.houses = []
          } else {
            this.houses = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getServices: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/service/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.services = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    textServices: item => (item.name === null ? 'n/a' : item.name),
    example2: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')',
    example3: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')' + ' (' + (item.fullname === '' ? 'n/a' : item.fullname) + ')',
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterNumberResident (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase() + item.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      }
      const searchText = queryText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterNumber (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterService (item, queryText) {
      var text = ''
      if (item.name === null) {
        text = 'n/a'
      } else {
        text = item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanFields () {
      this.errors = []
      this.notes = ''
      this.idHouse = {
        id: ''
      }
      this.idService = ''
      this.first_name = ''
      this.last_name = ''
      this.bandParcel = false
      this.idHouse2 = []
      this.bandMsgVacationMode = false
      this.bandInstructions = false
      this.msgInstructions = ''
      this.idGuestByEvent = null
      this.idGuestByDelivery = null
    },
    clear () {
      this.cleanFields()
      this.errors = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    rotateBase64Image180deg (base64Image, isClockwise, index) {
      // create an off-screen canvas
      var offScreenCanvas = document.createElement('canvas')
      var offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // cteate Image
      var img = new Image()
      img.src = base64Image

      // set its dimension to rotated size
      offScreenCanvas.height = img.height
      offScreenCanvas.width = img.width

      // rotate and draw source image into the off-screen canvas:
      if (isClockwise) {
        offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(180 * Math.PI / 180)
      } else {
        offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(-180 * Math.PI / 180)
      }
      offScreenCanvasCtx.drawImage(img, 0, 0)

      // encode image to data-uri with base64
      this.rotateimage = offScreenCanvas.toDataURL('image/jpeg', 100)
      var rotateimage2 = this.rotateimage.replace('data:image/jpeg;base64,', '')
      this.updateItemPhoto(index, rotateimage2)
      // this.photosCamera[index] = rotateimage2
      // console.log(rotateimage2)
      // this.imageCaptured = this.rotateimage
    },
    createAccessWithoutCode () {
      this.loading = true
      this.errors = []
      console.log('Access Without Code Created ....')
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('housing_unit', this.getProfile.idHousingUnit)
      bodyFormData.set('house', this.idHouse.id)
      if (this.idService !== undefined && this.idService.length > 0 && (this.first_name !== '' || this.last_name !== '')) {
        bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name + ' ' + '(' + this.idService.toUpperCase() + ')')
      } else {
        bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name)
      }
      bodyFormData.set('comments', this.notes)
      bodyFormData.set('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))

      if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
        fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
      }
      bodyFormData.append('photo', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          this.dialogData = false
          this.deleteItemPhoto(this.indexTag)
          setTimeout(this.clear, 3000)
          if (this.idGuestByEvent !== null) {
            console.log('Se actualiza Registro de Acceso de la invitado al Evento.')
            this.changeStatusGuestByEvent(ok.data.id)
          }
          if (this.idGuestByDelivery !== null) {
            console.log('Se actualiza Registro de Acceso al Delivery.')
            this.changeStatusGuestByDelivery(ok.data.id)
          }
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    changeStatusGuestByEvent (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/event/guest/status/' + this.idGuestByEvent + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    changeStatusGuestByDelivery (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/delivery/' + this.idGuestByDelivery,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    addEvent () {
      let { color, icon } = this.genAlert()
      const previousColor = this.items[0].color

      while (previousColor === color) {
        color = this.genColor()
      }
      this.items.push({
        id: this.nonce++,
        color,
        icon
      })
      if (this.nonce > 6) {
        this.items.pop()
      }
    },
    genAlert () {
      const color = this.genColor()

      return {
        color,
        icon: this.genIcon(color)
      }
    },
    genColor () {
      return COLORS[Math.floor(Math.random() * 3)]
    },
    genIcon (color) {
      return ICONS[color]
    },
    start () {
      this.interval = setInterval(this.addEvent, 3000)
    },
    stop () {
      clearInterval(this.interval)
      this.interval = null
    },
    create_acceso (index, aQr) {
      console.log(aQr)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/Access/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: aQr,
          comments: this.comments,
          id_guardhouse_checkin: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          console.log(response)
          this.errores_guard = this.$t('mensaje_alta_acceso_in')
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
          this.comments = ''
          this.deleteItem(index)
        })
        .catch(error => {
          console.log(error.response.data)
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    create_worker_access (index, aQr, status) {
      console.log(aQr)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: aQr,
          guard_house: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          console.log(response)
          if (status === 10) {
            this.errores_guard = this.$t('mensaje_alta_acceso_in')
          } else {
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
          }
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
          this.deleteItem(index)
        })
        .catch(error => {
          console.log(error.response.data)
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    update_acceso (index, pk) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/Access/Update/' + pk,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          console.log(response)
          this.head_color = 'green display-1 text--primary'
          this.errores_guard = this.$t('mensaje_alta_acceso_out')
          this.dialog_errores = true
          this.deleteItem(index)
        })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    },
    deleteRecord () {
      this.loading = true
      if (localStorage.getItem('qr_devices') !== null) {
        let band = false
        let devicesAux = JSON.parse(localStorage.getItem('qr_devices'))
        console.log('Auxiluar = ', devicesAux)
        for (let i = 0; !band && i < devicesAux.length; i++) {
          if (devicesAux[i].label === this.labelDevice) {
            console.log(devicesAux[i].label, '===', this.labelDevice)
            devicesAux[i] = Object.assign(devicesAux[i], { 'data': null })
            localStorage.setItem('qr_devices', JSON.stringify(devicesAux))
            this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
            band = true
          }
        }
        console.log(JSON.parse(localStorage.getItem('qr_devices')))
      }
      this.loading = false
    },
    deleteItem (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStoreQrCodes')) || []
      console.log(aux)
      if (index >= 0) aux.splice(index, 1)
      console.log(aux)
      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
    },
    updateItemCorrectionRequest (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStoreQrCodes')) || []
      console.log(aux)
      if (index >= 0) {
        aux[index].info.invitation.correction_request = true
      }
      console.log(aux)
      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
    },
    deleteItemPhoto (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStorePhotosCamera')) || []
      console.log(aux)
      if (index >= 0) aux.splice(index, 1)
      console.log(aux)
      localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
      this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
    },
    updateItemPhoto (index, newData) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStorePhotosCamera')) || []
      console.log(aux)
      if (aux.length >= 0) {
        aux[index].data = newData
        console.log(aux[index])
      }
      localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
      this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
    },
    takePicture2 () {
      console.log('Waiting for picture ...')
      this.loadingTakePicture = false
    },
    takePicture1 () {
      this.$store.commit('enableAdditionalPerson', false)
      localStorage.setItem('banderaAdditionalPerson', false)
      this.$store.commit('enableINEBack', false)
      localStorage.setItem('banderaINEBack', false)
      this.loadingTakePicture = true
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/device_activate/' + JSON.parse(localStorage.getItem('cam_devices'))[0].uuid + '/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {}
      }
      axios(config)
        .then(response => {
          console.log(response)
          setTimeout(this.takePicture2, 3000)
        })
        .catch(error => {
          console.log(error.response.data)
          this.loadingTakePicture = false
        })
    }
  }
}
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #439f46;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    th {
        text-align: left;
    }
    table, th, td {
      border:1px solid black;
    }

    th, td {
      text-align: center;
      padding: 8px;
    }

    tr:nth-child(even) {
      background-color: #D6EEEE;
    }
</style>
